"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _AssetsTab = _interopRequireDefault(require("./AssetsTab"));

var _DetailsTab = _interopRequireDefault(require("./DetailsTab"));

var _utils = require("../../../../../common/utils");

require("../styles/_asset-drawer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getCommentTitle(comment) {
  return (0, _utils.convertSecondsToReadable)(comment.timestamp);
}

var tabChildren = function tabChildren(_ref) {
  var video = _ref.video,
      selectedClip = _ref.selectedClip,
      onSelectBasicComment = _ref.onSelectBasicComment,
      onUpdateSelectedDrawerAssets = _ref.onUpdateSelectedDrawerAssets;
  return [{
    icon: 'info',
    component: /*#__PURE__*/_react.default.createElement(_DetailsTab.default, {
      key: "video-info"
    })
  }, {
    icon: 'medialibrary',
    component: /*#__PURE__*/_react.default.createElement(_AssetsTab.default, {
      key: "video-assets",
      onUpdateSelectedDrawerAssets: onUpdateSelectedDrawerAssets
    })
  }, {
    icon: 'comments',
    component: /*#__PURE__*/_react.default.createElement(_commonReact.CommentsTab, {
      getCommentTitle: getCommentTitle,
      key: "video-comments",
      isVideoReview: true,
      selectedGroupId: selectedClip && video.editingMode !== 'ADVANCED' ? video.clips.findIndex(function (clip) {
        return clip.clipId === selectedClip.clipId;
      }) : void 0,
      onSelectComment: video.editingMode === 'ADVANCED' ? void 0 : onSelectBasicComment,
      selectedClipId: video.editingMode === 'ADVANCED' ? void 0 : selectedClip && selectedClip.clipId
    })
  }];
};

function AssetDrawer(_ref2, ref) {
  var hiddenIndexes = _ref2.hiddenIndexes,
      stage = _ref2.stage,
      video = _ref2.video,
      commentFilterClip = _ref2.commentFilterClip,
      onSelectBasicComment = _ref2.onSelectBasicComment,
      onUpdateSelectedDrawerAssets = _ref2.onUpdateSelectedDrawerAssets;
  var children = tabChildren({
    video: video,
    selectedClip: commentFilterClip,
    onSelectBasicComment: onSelectBasicComment,
    onUpdateSelectedDrawerAssets: onUpdateSelectedDrawerAssets
  });
  var filteredChildren = hiddenIndexes ? children.filter(function (_, index) {
    return !hiddenIndexes.includes(index);
  }) : children;
  return (/*#__PURE__*/_react.default.createElement(_uiKit.Drawer, {
      className: "asset-drawer",
      isVertical: true,
      tabIcons: filteredChildren.map(function (_ref3) {
        var icon = _ref3.icon;
        return icon;
      }),
      startOpen: stage === 2,
      ref: ref
    }, filteredChildren.map(function (_ref4) {
      var component = _ref4.component;
      return component;
    }))
  );
}

var _default = (0, _react.memo)((0, _react.forwardRef)(AssetDrawer));

exports.default = _default;